module.exports = __webpack_public_path__ + "static/img/sideBoderBg.83829d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/sideBoderBg.png
// module id = IY50
// module chunks = 0